import { Injectable } from '@angular/core';

@Injectable()
export class ApiService {
  title = 'Angular 2';
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/api.service.ts